module.exports = __webpack_public_path__ + "img/info3.23d7f18c.png";